import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import CarealsDetail from './components/CarealsDetail';
import Cart from './components/Cart';
import { CartProvider } from './components/CartContext';
import Cereals from './components/cereals';
import ClayDetail from './components/ClayDetail';
import Contact from './components/Contact';
import DryRiceDetail from './components/dryDetails';
import Dryrice from './components/dryrice';
import EnquiryForm from './components/EnquiryForm';
import FlourDetail from './components/floureDetail';
import Flours from './components/flours';
import Footer from './components/Footer';
import FounderPage from './components/FounderPage';
import Hero from './components/Hero';
import JaggeryDetail from './components/JaggeryDetail';
import Lentils from './components/lentils';
import LentilsDetail from './components/lentilsDetails';
import Masala from './components/masala';
import MasalaDetail from './components/MasalaDetail';
import MilletDetail from './components/MilletDetail';
import Millets from './components/millets';
import Navbar from './components/Navbar';
import Oil from './components/oil';
import OilDetail from './components/OilDetail';
import OrderConfirmed from './components/OrderConfirmed';
import PickleDetail from './components/PickleDetail';
import Pickles from './components/pickles';
import Claypots from './components/pots';
import Products from './components/Products';
import Rice from './components/rice';
import RiceDetail from './components/RiceDetail';
import SaltDetail from './components/saltDetail';
import Salts from './components/salts';
import SauceDetail from './components/SauceDetail';
import Sauces from './components/sauces';
import ScrollToHashElement from './components/ScrollToHashElement';
import ScrollToTop from './components/ScrollToTop';
import ShippingPolicy from './components/shippingpolicy';
import Sugars from './components/sugars';
import Sundry from './components/sundry';
import VathalDetail from './components/VathalDetail';

function App() {
  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <ScrollToHashElement />
        <Navbar />
        <Routes>
          <Route path='/' element={<Hero />} />
          <Route path="/about" element={<Hero />} />
          <Route path="/products" element={<Products />} />
          <Route path="/rice" element={<Rice />} />
          <Route path="/oil" element={<Oil />} />
          <Route path="/oil/:type" element={<OilDetail />} />
          <Route path="/masala" element={<Masala />} />
          <Route path="/masala/:type" element={<MasalaDetail />} />
          <Route path="/lentils" element={<Lentils />} />
          <Route path="/sugars" element={<Sugars />} />
          <Route path='/salts' element={<Salts />} />
          <Route path='/dryrice' element={<Dryrice />} />
          <Route path='/flours' element={<Flours />} />
          <Route path='/pickles' element={<Pickles />} />
          <Route path='/sauces' element={<Sauces />} />
          <Route path='/millets' element={<Millets />} />
          <Route path='/sundry' element={<Sundry />} />
          <Route path='/cereals' element={<Cereals />} />
          <Route path='/pots' element={<Claypots />} />
          <Route path='/rice/:type' element={<RiceDetail />} />
          <Route path='/clay/:type' element={<ClayDetail />} />
          <Route path='/sugar/:type' element={<JaggeryDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path='/lentils/:type' element={<LentilsDetail />} />
          <Route path='/sundry/:type' element={<DryRiceDetail />} />
          <Route path='/salts/:type' element={<SaltDetail />} />
          <Route path='/flours/:type' element={<FlourDetail />} />
          <Route path='/pickles/:type' element={<PickleDetail />} />
          <Route path='/thokkus/:type' element={<SauceDetail />} />
          <Route path='/millets/:type' element={<MilletDetail />} />
          <Route path='/vathals/:type' element={<VathalDetail />} />
          <Route path='/careals/:type' element={<CarealsDetail />} />
          <Route path="/enquiry" element={<EnquiryForm />} />
          <Route path="/order-confirmed" element={<OrderConfirmed />} />
          <Route path="/shippingpolicy" element={<ShippingPolicy />} />
          <Route path="/founder" element={<FounderPage />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </Router>
      
    </CartProvider>
  );
}

export default App;
